/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

/**
 * User role enumeration.
 */
export type UserRole = typeof UserRole[keyof typeof UserRole];


export const UserRole = {
  superadmin: 'superadmin',
  admin: 'admin',
  editor: 'editor',
  publisher: 'publisher',
  user: 'user',
} as const;
